import { i18n } from '@fs/zion-locale'

const searchPlacesQueryKey = (params) => [
  'searchPlaces',
  params.text,
  params.limit,
  params.output,
  params.reqYears,
  params.optYears,
  params.optParents,
  i18n.language,
]

export default searchPlacesQueryKey
